const { regexes, accountType } = require('@transfeeradev/api-enums');
const defaultSchema = require('./defaultSchema');

const bancoDoBrasilSchema = {
  agency: {
    digit: {
      pattern: regexes.bankAccount.DIGIT
    }
  },
  account: {
    maxLength: 8,
    digit: {
      pattern: regexes.bankAccount.DIGIT
    }
  },
  accountType: {
    allowedTypes: [...defaultSchema.accountType.allowedTypes, accountType.CONTA_FACIL]
  }
};

module.exports = bancoDoBrasilSchema;
